import React from "react";
import { Card } from "@veneer/core";
import { QuestionOptions } from "./QuestionOptions";

interface QuestionCardProps {
  question: any;
  index: number;
  handleChangeCheckbox: (e: any, evaluationQuestionID: number) => void;
  handleChangeAnswers: (e: any, evaluationQuestionID: number) => void;
  handleChangeSelectEvaluation: (
    e: any,
    optionID: number,
    evaluationQuestionID: number
  ) => void;
}

export const QuestionCard: React.FC<QuestionCardProps> = ({
  question,
  index,
  handleChangeCheckbox,
  handleChangeAnswers,
  handleChangeSelectEvaluation,
}) => {
  return (
    <Card
      appearance="outlined"
      className="modalEvaluationCard"
      content={
        <div className="modalEvaluationQuestion">
          <h6>
            {index + 1 + ". "}
            {question.question}
          </h6>
          <br />

          <QuestionOptions
            question={question}
            handleChangeCheckbox={handleChangeCheckbox}
            handleChangeAnswers={handleChangeAnswers}
            handleChangeSelectEvaluation={handleChangeSelectEvaluation}
          />
        </div>
      }
    />
  );
};
